import { CheckIcon } from 'assets/icons';
import BadgeSquare from 'components/badge/badgeSquare';
import { useEffect } from 'react';
import MediaQuery from 'react-responsive';
import { dateWordShort } from '../../helper/helper';
import UseContext from '../../hooks/useContext';
import useModal from '../modal/useModal';
import { MODAL_MAP } from '../../helper/identityDocuments';

const AdminCollapseFile = ({ title, dateAdd, status, type, _id, id_user }) => {
  const {
    setAdminTempWorkerId,
    setAdminUserId,
    setAdminType,
    openModal,
    setOpenModal,
  } = UseContext();
  const { toggle } = useModal();

  const openDocument = (e) => {
    if (e) e.preventDefault();
    setAdminTempWorkerId(_id);
    setAdminUserId(id_user);
    setAdminType(type);
    const modal = MODAL_MAP[type];
    if (modal) toggle(modal);
  };

  useEffect(() => {
    if (openModal) {
      toggle(openModal);
      setOpenModal(false);
    }
  }, [openModal]);

  return (
    <div 
      className={'py-2 px-3 flex items-center hover:bg-gray-100 transition-colors rounded gap-3 cursor-pointer'}
      onClick={openDocument}
    >
      <div className={'flex items-center gap-1 min-w-0 tab:min-w-[200px] text-left flex-shrink'}>
        <span className={'underline text-sm whitespace-nowrap'}>{title}</span>
        <span className={'text-gray-500 text-sm whitespace-nowrap'}>({dateWordShort(new Date(dateAdd))})</span>
      </div>
      <div className="flex-1" />
      <div className={'max-w-[120px] truncate'}>
        <BadgeSquare type={status} />
      </div>
      <MediaQuery minWidth={768}>
        <div className={'flex items-center'} onClick={(e) => e.stopPropagation()}>
          <button className={'hover:bg-gray-200 transition-colors rounded p-1 w-8 h-8 flex items-center justify-center'} onClick={openDocument}>
            <CheckIcon w={24} h={12} color={'#111827'} />
          </button>
        </div>
      </MediaQuery>
    </div>
  );
};

export default AdminCollapseFile;
